/**
 * Shared popular job links for the jobs board (filter panel, browse-more box)
 * and footer SEO. Roles match Footer/Skills DefaultSkills freelancer set;
 * countries match FooterSections/LocationJobs.
 */

export const POPULAR_JOB_COUNTRIES = [
  {
    label: 'United States',
    shortLabel: 'USA',
    slug: 'united-states',
    footerLabel: 'Find jobs in the USA',
  },
  {
    label: 'United Kingdom',
    shortLabel: 'UK',
    slug: 'united-kingdom',
    footerLabel: 'Find jobs in the UK',
  },
  {
    label: 'Canada',
    shortLabel: 'Canada',
    slug: 'canada',
    footerLabel: 'Find jobs in Canada',
  },
  {
    label: 'Australia',
    shortLabel: 'Australia',
    slug: 'australia',
    footerLabel: 'Find jobs in Australia',
  },
  {
    label: 'Germany',
    shortLabel: 'Germany',
    slug: 'germany',
    footerLabel: 'Find jobs in Germany',
  },
];

/** Popular / Browse-more country link order (UK first). */
export const POPULAR_JOB_COUNTRY_SHORT_ORDER = [
  'united-kingdom',
  'united-states',
  'canada',
  'australia',
  'germany',
];

export const getPopularJobCountriesShort = () =>
  POPULAR_JOB_COUNTRY_SHORT_ORDER.map((slug) =>
    POPULAR_JOB_COUNTRIES.find((country) => country.slug === slug)
  ).filter(Boolean);

export const POPULAR_JOB_ROLES = [
  {
    name: 'Animator',
    slug: 'animators',
    footerLabel: 'Animation jobs',
  },
  {
    name: 'Videographer',
    slug: 'videographers',
    footerLabel: 'Videographer jobs',
  },
  {
    name: 'Graphic Designer',
    slug: 'graphic-designers',
    footerLabel: 'Graphic design jobs',
  },
  {
    name: 'Pitch Deck Designer',
    slug: 'pitch-deck-designers',
    footerLabel: 'Pitch deck designer jobs',
  },
  {
    name: 'Social Media Marketer',
    slug: 'social-media-marketers',
    footerLabel: 'Social media marketing jobs',
  },
  {
    name: 'Digital Marketer',
    slug: 'digital-marketers',
    footerLabel: 'Digital marketing jobs',
  },
  {
    name: 'Music Composer',
    slug: 'music-composers',
    footerLabel: 'Music composer jobs',
  },
  {
    name: 'Music Producer',
    slug: 'music-producers',
    footerLabel: 'Music producer jobs',
  },
  {
    name: 'Web Designer',
    slug: 'web-designers',
    footerLabel: 'Web designer jobs',
  },
  {
    name: 'Web Developer',
    slug: 'web-developers',
    footerLabel: 'Web developer jobs',
  },
];
